import { useRef } from "react";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ModalPop from "./ModalPop";

const Banner = () => {
  const bannerList = [
    {
      txt: "images/bannerTxt1.png",
      icon: "images/bannerIcon1.png",
    },
    {
      txt: "images/bannerTxt2.png",
      icon: "images/bannerIcon2.png",
    },
    {
      txt: "images/bannerTxt3.png",
      icon: "images/bannerIcon3.png",
    },
    {
      txt: "images/bannerTxt1.png",
      icon: "images/bannerIcon1.png",
    },
    {
      txt: "images/bannerTxt2.png",
      icon: "images/bannerIcon2.png",
    },
    {
      txt: "images/bannerTxt3.png",
      icon: "images/bannerIcon3.png",
    },
  ];

  const cate = [
    "유품정리",
    "쓰레기집",
    "특수청소",
    "빈집정리",
    "창고정리",
    "폐기물처리",
    "이사정리",
    "고독사청소",
  ];

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };
  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <div className=" relative w-full h-full pt-16 lg:pt-10 px-[calc((100%-var(--container))/2)]">
        <Swiper
          slidesPerView={1}
          autoplay={{
            delay: 4000,
            disableOnInteraction: false,
            stopOnLastSlide: false,
          }}
          loop={true}
          loopAdditionalSlides={2}
          modules={[Autoplay]}
          className="mySwipe relative w-full h-full"
        >
          {bannerList.map((v, i) => (
            <SwiperSlide
              key={i}
              className=" relative w-full h-full overflow-hidden"
            >
              <div className="relative w-full h-full lg:grid grid-cols-5 items-end min-h-[330px] px-1">
                <div className="lg:col-span-3 relative w-full h-full grid items-center">
                  <div className=" relative w-fit h-fit mx-auto lg:ml-auto z-10">
                    <div className=" relative w-fit h-fit">
                      <img
                        src={v.txt}
                        alt="하수구막힘제로"
                        className="!relative w-auto h-full max-h-64"
                      />
                    </div>
                    <div className=" relative w-full h-fit flex flex-wrap lg:flex-nowrap justify-end items-center gap-1 sm:gap-3 mt-10 lg:mt-16">
                      <button
                        type="button"
                        onClick={openfunc}
                        className="relative w-fit h-fit bg-primary text-point rounded-full py-2 px-6 text-sm xs:text-base lg:text-lg mb-2 lg:mb-0"
                      >
                        무료&nbsp;출장견적요청
                      </button>
                      <button
                        type="button"
                        onClick={() =>
                          (window.location.href = "tel:010-4321-9728")
                        }
                        className="relative w-fit h-fit bg-primary text-white rounded-full py-2 px-6 text-sm xs:text-base lg:text-lg"
                      >
                        비대면&nbsp;·&nbsp;비밀보장&nbsp;견적요청
                      </button>
                    </div>
                  </div>
                </div>
                <div className="lg:col-span-2 relative w-full h-full lg:h-[550px] grid items-end mt-5 lg:mt-0">
                  <img
                    src={v.icon}
                    alt="하수구막힘제로"
                    width={937}
                    height={686}
                    className="w-full h-full object-cover overflow-visible"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="hidden lg:block relative w-full h-fit lg:px-[calc((100%-var(--container))/2)] py-2 overflow-hidden border-t border-b">
        <ul className="relative w-full h-fit border-l text-center xl:grid items-center justify-items-center grid-cols-8 text-[#392020]">
          {cate.map((v, i) => (
            <li
              key={i + "pc"}
              className="text-center relative w-full h-fit border-r"
            >
              <p className="text-lg">{v}</p>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default Banner;
